import { useState } from "react";
import Container from "../components/Container";
import Stats from '../components/RSVPStats'
import RSVPListByGroup from "../components/RSVPListByGroup";
import RSVPHistory from "../components/RSVPHistory";
import RSVPUpdates from "../components/RSVPUpdates";
import RSVPCards from "../components/RSVPCards";
import PageFade from "../motions/PageFade";
import RSVPListByGuest from '../components/RSVPListByGuest';
import RSVPContactInfo from "../components/RSVPContantInfo";

function Admin() {

    const [currentResponseID, setCurrentResponseID] = useState(null)

    return (
        <PageFade>
            <Container>
                <div className="title text-gold mb-6">RSVP Responses</div>
                <div>
                    {!currentResponseID ? (
                        <>
                            <RSVPContactInfo />
                            <Stats />
                            <RSVPListByGuest />
                            <RSVPUpdates />
                            <RSVPListByGroup setCurrentResponseID={setCurrentResponseID} />
                            <RSVPCards />
                        </>
                    ) : (
                        <RSVPHistory currentResponseID={currentResponseID} setCurrentResponseID={setCurrentResponseID} />
                    )}
                </div>
            </Container>
        </PageFade>
    );

}

export default Admin;
